var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M181.974 53.942c.459.055.99.64.847 1.478-.12.711-.662 1.113-.873 1.479-.212.364-.018 1.044-.018 1.044s-1.801-1.446-1.36-2.952c.308-1.056.944-1.104 1.404-1.049",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.923 56.295c.378.048.818.53.7 1.224-.1.588-.548.92-.723 1.224-.176.301-.014.865-.014.865s-1.49-1.199-1.127-2.444c.256-.874.782-.914 1.164-.869",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.862 58.127c.283.035.61.397.524.916-.076.443-.412.69-.543.918-.132.227-.01.648-.01.648s-1.119-.898-.846-1.832c.193-.655.587-.685.875-.65",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.763 60.33c.293.035.63.408.54.943-.077.456-.423.714-.558.947-.136.232-.01.666-.01.666s-1.152-.923-.87-1.885c.196-.676.602-.707.898-.67",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.145 60.573s.275-.288.031-.668c-.164-.25-.958-.28-1.107-.039-.21.337.054.648.054.648s.538-.456 1.022.059",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.285 52.31v1.822h1.513V52.31h-1.513",
    style: {
      fill: "#ffd7a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.285 54.132-1.348.261s.664 1.693 2.103 1.693l.002-1.954h-.757m1.513 0 1.347.261s-.663 1.693-2.103 1.693v-1.954h.756",
    style: {
      fill: "#ffd7a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.107 53.942c-.458.055-.99.64-.847 1.478.12.711.662 1.113.875 1.479.21.364.017 1.044.017 1.044s1.8-1.446 1.36-2.952c-.31-1.056-.945-1.104-1.405-1.049",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.16 56.295c-.38.048-.818.53-.702 1.224.1.588.548.92.723 1.224.176.301.015.865.015.865s1.49-1.199 1.125-2.444c-.255-.874-.78-.914-1.161-.869",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.222 58.127c-.285.035-.613.397-.525.916.074.443.41.69.541.918.132.227.01.648.01.648s1.119-.898.845-1.832c-.192-.655-.585-.685-.871-.65",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.319 60.33c-.292.035-.63.408-.541.943.078.456.423.714.559.947.135.232.011.666.011.666s1.15-.923.87-1.885c-.198-.676-.604-.707-.9-.67",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.937 60.573s-.275-.288-.032-.668c.162-.25.958-.28 1.107-.039.21.337-.054.648-.054.648s-.538-.456-1.02.059",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.34 67.742 3.6-.777c-.723 5.323-1.432 8.527-1.561 9.863h-1.595c.005-2.016-.417-6.065-.443-9.086m2.038 9.28c-.031.317-.045.487-.045.487h-1.552l.002-.487h1.595",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.556 78.712h-1.94v-1.27h1.94v1.27m-1.898-1.616h1.856v-.268h-1.856v.268",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.423 67.742-3.599-.777c.723 5.323 1.432 8.527 1.561 9.863h1.595c-.005-2.016.417-6.065.443-9.086m-2.038 9.28.045.487h1.552l-.002-.487h-1.595",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.208 78.712h1.94v-1.27h-1.94v1.27m1.898-1.616h-1.856v-.268h1.856v.268",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.937 54.393h-.8s-1.837 6.28-2.991 9.058c0 0 .222 2.843.932 4.693.71 1.85 1.908 2.707 4.963 2.707V55.177l-2.104-.784m4.208 0h.803s2.319 5.515 3.508 8.625c0 0-.303 7.833-6.415 7.833V55.177l2.104-.784",
    style: {
      fill: "#a6d2ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.895 48.084c0 2.294-.988 5.294-3.064 5.312-.104 0-1.325-2.738-2.335-2.738-.147 0-.3.053-.456.143v-8.757c3.234 0 5.855 2.705 5.855 6.04",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.527 49.822s-1.566 3.923-.32 4.65c.192.111.816.62.978.467 1.451-1.38.397-2.956.847-3.704.452-.747-1.148-4.086-1.505-1.413m-9.339-1.738c0 2.294.986 5.294 3.063 5.312.104 0 1.325-2.738 2.335-2.738.148 0 .3.053.454.143v-8.757c-3.233 0-5.852 2.705-5.852 6.04",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.556 49.822s1.564 3.923.317 4.65c-.19.111-.815.62-.976.467-1.453-1.38-.396-2.956-.847-3.704-.451-.747 1.148-4.086 1.506-1.413m4.95-5.557s-1.936 2.997-4.923 3.08c0 0-.968-2.718.975-3.996 1.945-1.279 4.03 0 4.03 0l-.082.916",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.506 44.265s1.452 3.019 1.911 3.205c0 0 .658-.301.584-1.148-.075-.85-.951-3.677-2.32-3.394-1.37.28-.413.854-.175 1.337",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11 48.351c0 2.474-2.268 4.48-5.068 4.48-2.801 0-5.072-2.006-5.072-4.48 0-2.474 2.27-4.479 5.072-4.479 2.8 0 5.068 2.005 5.068 4.48",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.008 44.762s-.54 2.919-1.844 3.876c-1.303.957-.866-2.976 1.844-3.876",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.597 44.487s5.28 3.786 8.248 1.549c.395-.298 1.05-1.227.919-1.785 0 0-.92 1.475-3.264-.232-1.344-.977-5.32-1.054-5.903.468",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.617 49.326c0 .36-.352.652-.787.652-.437 0-.79-.292-.79-.652 0-.36.353-.651.79-.651.435 0 .787.29.787.65m4.848.001c0 .36.351.652.788.652.435 0 .788-.292.788-.652 0-.36-.353-.651-.788-.651-.437 0-.788.29-.788.65",
    style: {
      fill: "#fdb5ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.931 49.326a.706.706 0 0 1-.695.716.705.705 0 0 1-.693-.716c0-.396.31-.715.693-.715.384 0 .695.319.695.715m8.219 0c0 .395.312.716.695.716a.707.707 0 0 0 .695-.716.705.705 0 0 0-.695-.715.704.704 0 0 0-.695.715",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.295 46.073c-.483 0-.897.173-1.107.423 0 0 .52-.295 1.107-.295a2.38 2.38 0 0 1 1.107.295c-.21-.25-.624-.423-1.107-.423",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.083 43.165c0 .21-.161 1.141-.357 1.141-.198 0-.36-.931-.36-1.141 0-.21.162-.382.36-.382.196 0 .357.171.357.382",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.96 43.402c.176.109.867.73.766.904-.103.176-.96-.162-1.134-.27a.382.382 0 0 1-.133-.514.358.358 0 0 1 .501-.12",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.579 44.516c.18-.098 1.053-.388 1.147-.21.091.181-.63.765-.81.863a.357.357 0 0 1-.494-.147.38.38 0 0 1 .157-.506",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.309 45.429c.011-.21.219-1.132.417-1.123.196.012.31.95.3 1.161-.013.21-.182.372-.378.361-.197-.01-.35-.19-.34-.4",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.442 45.252c-.168-.117-.827-.776-.716-.946.11-.168.948.217 1.117.333a.382.382 0 0 1 .105.52.356.356 0 0 1-.506.093",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.879 44.16c-.184.088-1.071.332-1.153.146-.085-.183.667-.727.851-.816a.36.36 0 0 1 .487.173.382.382 0 0 1-.185.496",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.985 44.306c0 .15-.116.27-.26.27a.265.265 0 0 1-.26-.27c0-.148.115-.268.26-.268.144 0 .26.12.26.268",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.55 65.882a.557.557 0 0 1-.548-.565c0-.313.246-.565.548-.565.304 0 .549.252.549.565a.557.557 0 0 1-.55.565m-5.122-1.864a.556.556 0 0 1-.548-.566c0-.313.245-.566.548-.566.303 0 .549.253.549.566a.557.557 0 0 1-.55.566m2.127 3.422a.558.558 0 0 1-.548-.564c0-.313.246-.566.548-.566.303 0 .549.253.549.566a.558.558 0 0 1-.549.565m-6.928-3.292a.557.557 0 0 1-.547-.566c0-.312.246-.565.547-.565.304 0 .55.253.55.565a.557.557 0 0 1-.55.566",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.34 78.677h1.743v-13.9h-1.743v13.9m-26.6 0h-1.743v-13.9h1.742v13.9",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.028 67.542h-28.411v-4.033h28.41v4.033",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.083 65.526h-30.086v-2.89h30.086v2.89",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.712 60.948h-7.59a.99.99 0 0 0-.991.99v.702c0 .547.443.99.99.99h7.591c.03 0 .054-.016.082-.018v-2.649c-.028-.002-.053-.015-.082-.015",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.794 61.359h-7.463c-.439 0-.793.31-.793.692v.49c0 .382.354.69.793.69h7.463V61.36",
    style: {
      fill: "#f9d2b5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.04 50.324v.25s1.309.084 2.078-.66c0 0-.84.41-2.078.41m0 0v.25s-1.31.084-2.076-.66c0 0 .838.41 2.076.41m0 .627v.256s.913 0 1.203-.409c0 0-.707.16-1.203.153m0 0v.256s-.914 0-1.203-.409c0 0 .707.16 1.203.153",
    style: {
      fill: "#dab289",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81 49.795c.165.146.25.101.395.515 0 0 .018-.455-.263-.612-.158-.089-.178.055-.131.097m-3.542 0c-.163.146-.251.101-.395.515 0 0-.015-.455.264-.612.156-.089.176.055.13.097",
    style: {
      fill: "#dab289",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.295 54.393s-3.012 5.781-2.12 8.023c.352.887 1.77.623 2.12-1.701.349-2.325.99-6.121.99-6.121s-.515-2.697-1.41-2.71c-.824-.01.278 1.848.42 2.51",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.137 54.393s-1.394-.419-1.9 1.89c-.507 2.309.097 5.841 1.07 6.236.971.395.857-3.443.701-4.402-.155-.958.017-2.182.017-2.182l.112-1.542m4.652 0s3.012 5.781 2.12 8.023c-.352.887-1.77.623-2.12-1.701-.349-2.325-.99-6.121-.99-6.121s.515-2.697 1.41-2.71c.823-.01-.278 1.848-.42 2.51",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.948 54.393s1.393-.419 1.9 1.89c.506 2.309-.098 5.841-1.07 6.236-.972.395-.86-3.443-.702-4.402.155-.958-.017-2.182-.017-2.182l-.111-1.542",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17 47.622c0 .292-.232.53-.514.53a.523.523 0 0 1-.514-.53c0-.293.23-.531.514-.531.282 0 .513.238.513.53",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.925 47.495c0 .12-.095.22-.213.22a.218.218 0 0 1-.214-.22c0-.122.096-.22.214-.22s.213.098.213.22",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.321 47.622c0 .292.229.53.512.53a.523.523 0 0 0 .515-.53.524.524 0 0 0-.515-.531.522.522 0 0 0-.512.53",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.565 47.495c0 .12.096.22.213.22.117 0 .212-.1.212-.22a.216.216 0 0 0-.212-.22.217.217 0 0 0-.213.22",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-305.93 -84.849) scale(2.0181)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent7);
export default __webpack_public_path__ + "static/media/student7.615a89df076d4c6bad121497fce4e8e0.svg";
export { ForwardRef as ReactComponent };